const n = ({ minDate: r, maxDate: s, currentYear: t }) => {
  const o = [], l = r ? r.getFullYear() : t - 100, a = s ? s.getFullYear() : t + 25;
  for (let e = l; e <= a; e++)
    o.push(e);
  return o;
};
export {
  n as getYears
};
